import { EducationalBriefs } from "../..";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IEducationalBrief } from "../types";

export type IEducationalBriefUpdateMutationParameters = {
    educationalBrief: RelationalValue<IEducationalBrief>;
    payload: EducationalBriefs;
};

export type IEducationalBriefUpdateMutationResult = IEducationalBrief;

export const educationalBriefUpdateMutation: IApiMutationFunction<IEducationalBriefUpdateMutationParameters> = ({
    educationalBrief,
    payload,
}) => {
    return {
        method: "PUT",
        url: `/educational_briefs/${mapRelationalValue(educationalBrief)}`,
        data: payload,
    };
};

export const useEducationalBriefUpdateMutation = createApiMutationHook<
    IEducationalBriefUpdateMutationParameters,
    IEducationalBriefUpdateMutationResult
>(educationalBriefUpdateMutation);
